import React from 'react'
import { Helmet } from 'react-helmet-async'
import Contact from '@/components/main/contact'
import SeoMetaData from '@/components/SeoMetaData'
import { config } from '@/lib/config'
import ContactCsiFestesContent from '@/components/contact/ContactCsiFestesContent'

export default function ContactCsiFestes() {
  return (
    <>
      <Helmet>
        <title>Kapcsolat - Csí-festés | BeArt Művészetterápia</title>
        <meta name="description" content="Jelentkezés Csí-festés programra" />
        <link rel="canonical" href="https://beart.hu/kapcsolat/csi-festes" />
      </Helmet>
      
      <SeoMetaData
        seoTitle="Kapcsolat (Csí-festés) | BeArt Művészetterápia"
        seoDescription="BeArt Művészetterápia, Art Coaching, családállítás, coaching, önismeret - művészetterápiás csoportok, egyéni és csoportos alkalmak, szervezeteknek kiégés megelőzés programok, önismereti foglalkozások"
      />
      
      <section className="mx-auto mb-8 mt-8 flex w-3/4 rounded-lg bg-[#ffcc99] bg-opacity-50 text-black shadow">
        <Contact
          title="Jelentkezés a Csí-festés művészetterápiás foglalkozásra"
          hidden="csi-festes"
          content={<ContactCsiFestesContent />}
        >
          <img
            src={`${config.basePath}/images/csi/csifestes-tengely.jpg`}
            alt="Csí-festés"
            width={"100%"}
          />
        </Contact>
      </section>
    </>
  )
}
